<template>
	<div class="flex w-full bg-img content-message-info" v-if="mounted">
		<div
			class="
				vx-col
				flex
				items-center
				justify-center
				flex-col
				sm:w-1/2
				md:w-3/5
				lg:w-3/4
				xl:w-1/2
				mx-auto
				text-center
			"
		>
			<img src="@/assets/images/pages/forgot-password.png" alt="messages" class="mx-auto mb-4" />
			<h1 class="sm:mx-0 mx-4 sm:mb-5 mb-5 d-theme-heading-color g-subtitle">
				{{ title }}
			</h1>
			<p class="sm:mx-0 mx-4 sm:mb-12 mb-5 text-primary g-label--normal">
				{{ text }}
			</p>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: "",
		},
		text: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			mounted: false,
		};
	},
	mounted() {
		setTimeout(() => {
			this.mounted = true;
		}, 100);
	},
};
</script>
